<template>
  <a-card id="detail-product">
    <h4 class="mb-4">
      {{ $t('product.product_details') }}
    </h4>
    <a-form-model-item :label="$t('product.product_name')" prop="detail.title">
      <a-input v-model="detail.title" size="large" :disabled="isLoading" @blur="$emit('title')" />
    </a-form-model-item>
    <a-form-model-item :label="$t('product.categories')" prop="detail.category_id">
      <a-input-group compact>
        <a-cascader
          v-model="detail.category_id"
          placeholder=""
          size="large"
          class="text-left w-100"
          popup-class-name="kategori-options"
          :field-names="{ label: 'name', value: 'id', children: 'children' }"
          :options="categoryOptions"
          :disabled="isLoading"
          @change="onChangeCategory"
        />
      </a-input-group>
    </a-form-model-item>
    <a-form-model-item :label="$t('product.brand')" prop="detail.brand_id">
      <a-select
        v-if="filteredBrands.length > 0"
        v-model="detail.brand_id"
        size="large"
        class="select-antd-default"
        :placeholder="$t('product.search_select_brand')"
        allow-clear
        show-search
        :filter-option="filterOption"
        :disabled="isLoading"
      >
        <a-select-option v-for="brd in filteredBrands" :key="brd.id">
          {{ brd.title }}
        </a-select-option>
      </a-select>
      <a-input v-else v-model="detail.brand_id" size="large" />
    </a-form-model-item>
    <a-row>
      <a-col :span="8">
        <a-form-model-item :label="$t('product.item_condition')" prop="detail.condition">
          <a-checkbox :disabled="isLoading" @change="onChangeCondition">
            {{ $t('product.used_condition') }}
          </a-checkbox>
        </a-form-model-item>
      </a-col>
      <a-col :span="8">
        <a-form-model-item :label="$t('product.importLabel')" prop="detail.imported">
          <a-checkbox v-model="detail.imported" :disabled="isLoading">
            {{ $t('product.import') }}
          </a-checkbox>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-form-model-item :label="$t('product.description')" prop="detail.long_description">
      <TextEditor
        v-model="detail.long_description"
        :placeholder="$t('product.write_something')"
        :disabled="isLoading"
        @change="$emit('validate', 'detail.long_description')"
      />
    </a-form-model-item>
  </a-card>
</template>

<script>
import TextEditor from '@/components/Input/TextEditor/index.vue'

export default {
  name: 'DetailProduct',
  components: { TextEditor },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    brands: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    detail: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    categoryOptions() {
      return this.categories
    },
    filteredBrands() {
      return this.brands
    },
  },
  methods: {
    onChangeCategory(value) {
      this.detail.category = value.length
        ? this.categoryOptions.find(category => category.id == value[0])
        : {}
      this.$emit('validate', 'detail.category_id')
    },
    onChangeCondition(event) {
      this.detail.condition = event.target.checked ? 'USED' : 'NEW'
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
      )
    },
  },
}
</script>

<style lang="scss">
.kategori-options ul.ant-cascader-menu {
  height: auto;
  max-height: 180px;
}
</style>